import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/**
 * One query client for the application.
 *
 * The retry policy is the interesting part: an authorisation failure or a
 * missing resource is an answer, not a transient fault, and retrying it three
 * times only delays telling the user.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isRetryable) return false;
          return failureCount < 2;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        // A mutation carries an idempotency key, so an automatic retry would be
        // safe — but a failed mutation usually needs the user to see what
        // happened and decide, so retries are explicit.
        retry: false,
      },
    },
  });
}
